import React from 'react';
import classNames from 'classnames';
import Box from '@material-ui/core/Box';
import { createStyles, withStyles } from '@material-ui/core';

const styles = (theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: theme.spacing(1),
      boxSizing: 'border-box',
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.spacing(0.5),
      marginRight: theme.spacing(2),
    },

    image: {},

    sizeSmall: {
      '&$root': {
        width: theme.spacing(5.5),
        height: theme.spacing(5.5),
      },

      '& $image': {
        maxWidth: theme.spacing(3.5),
        maxHeight: theme.spacing(3.5),
      },
    },

    sizeMedium: {
      '&$root': {
        width: theme.spacing(7.5),
        height: theme.spacing(7.5),
      },

      '& $image': {
        maxWidth: theme.spacing(5.5),
        maxHeight: theme.spacing(5.5),
      },
    },
  });

const LogoImage = ({
  className,
  classes,
  src,
  alt,
  small,
}: {
  className?: string;
  classes: any;
  src: string;
  alt?: string;
  small?: boolean;
}) => (
  <Box
    className={classNames(
      className,
      classes.root,
      small && classes.sizeSmall,
      !small && classes.sizeMedium
    )}>
    <img className={classes.image} src={src} alt={alt} />
  </Box>
);

export default withStyles(styles)(LogoImage);
